//币种下拉
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import { Select } from "antd";
import XtSvg from "components/Xt/Svg";
import styles from "./index.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";
// import icon404 from "assets/images/common/icon404.png";

export default observer(({ value, onChange, className }) => {
  const t = useTranslation();
  const { finance, fund } = useStore();

  const options = useMemo(() => {
    const ary = [];
    fund.currencyList.map((obj) => {
      if (!obj) return;
      ary.push({
        value: obj.currency,
        label: obj.currency.toUpperCase(),
      });
    });
    return ary;
  }, [fund.currencyList]);

  return (
    <div className={cx(styles.main, className)}>
      <XtSvg icon={`search`} />
      <Select
        value={value}
        className={cx(styles.select)}
        showSearch
        allowClear
        placeholder={t("finance.searchCrypto")}
        // optionFilterProp="children"
        bordered={false}
        showArrow={false}
        onChange={onChange}
        // onSearch={onSearch}
        // filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
        options={options}
      />
    </div>
  );
});
